// extracted by mini-css-extract-plugin
module.exports = {"main-image":"FaqHomeTemplate_main-image__k5tna","link":"FaqHomeTemplate_link__OBbqc"};